
















































import { CIcon } from '@coreui/icons-vue'
import { cilCamera, cilX } from '@coreui/icons-pro'
import Vue from 'vue'

export default Vue.extend({
  name: 'ImagePicker',
  data: function () {
    return {
      cameraIcon: cilCamera,
      xIcon: cilX,
      imageData: null,
      imageHeight: 0,
      imageWidth: 0,
      alertProp: null,
    }
  },
  props: {
    imageUrl: {
      type: String,
      default: '',
    }
  },
  methods: {
    selectFile: async function (): Promise<void> {
      ;(this.$refs.fileinput as HTMLInputElement).click()
    },
    fileSelectionChanged() {
      const files = (this.$refs.fileinput as HTMLInputElement).files
      if (files && files[0]) {
        const file = files[0]
        this.$emit('selection-changed', file)

        //updated preview
        this.imageData = URL.createObjectURL(file)
        const img = new Image()

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const setDimensions = this.setDimensions
        img.onload = function () {
          const me = this as any
          setDimensions(me.width, me.height)
        }
        img.src = URL.createObjectURL(file)
      }
    },
    setDimensions(x: number, y: number) {
      this.imageWidth = x
      this.imageHeight = y
    },
  },
  components: {
    CIcon,
  },
})
